var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71828 9.36692C5.95259 8.58765 5.95259 7.32672 6.71828 6.55136L12.6078 0.583475C12.6156 0.575643 12.6233 0.571727 12.6311 0.563895C12.9868 0.215377 13.4663 0 14 0C14.5337 0 15.0132 0.215377 15.3689 0.563895C15.3767 0.571727 15.3844 0.575643 15.3921 0.583475L21.2817 6.54745C22.0474 7.32672 22.0474 8.58765 21.2817 9.36301C20.8989 9.75068 20.3923 9.94648 19.8896 9.94648C19.3869 9.94648 18.8841 9.75068 18.4974 9.36301L15.9645 6.79807V19.055C15.9645 20.1553 15.0828 21.0443 14 21.0443C12.9172 21.0443 12.0355 20.1514 12.0355 19.055V6.79807L9.50258 9.36301C8.73303 10.1423 7.48783 10.1462 6.71828 9.36692ZM25.5355 26.0214H2.46448C1.37783 26.0214 0.5 26.9142 0.5 28.0107C0.5 29.1111 1.3817 30 2.46448 30H25.5355C26.6222 30 27.5 29.1072 27.5 28.0107C27.5 26.9103 26.6222 26.0214 25.5355 26.0214Z",
    fill: "#CB34FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.6491f115e41f15fb9f7fc27fe86a23f1.svg";
export { ForwardRef as ReactComponent };